import React, { Component } from "react";

import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

// import moment from "moment";
import ExportCOAModal from "../ExportCOA/ExportCOAModal";
import ListViewContentLoader from "./Loader/ListViewContentLoader";
import PinList from "./PinList";
import EnvSearch from "./Search/EnvSearch";

import addFileIcon from "../../../../../assets/images/environment/addIconLightBlue.svg";
import { ReactComponent as NewSwabIcon } from "../../../../../assets/images/environment/addSwabIconLightBlue.svg";
// import { ReactComponent as ExportCOA } from "../../../../../assets/images/environment/export.svg";
import pumpkin from "../../../../../assets/images/environment/pumpkin.gif";

import "./AnalyticsListView.css";

export default class AnalyticsListView extends Component {
  state = {
    isSearching: false,
    exportCOAModal: false,
    isHovered: false,
  };

  docUploadInput = React.createRef();

  // clearCalendar = () => {
  //   this.setState({
  //     dateSelected: "",
  //     prevDateSelected: "",
  //     showCalendar: false,
  //   });
  // }

  handleAddFile = () => {
    // console.log("add excel click", this.docUploadInput.current);
    // this.docUploadInput.current.value = ""; // need to clear previous file input
    // this.docUploadInput.current.click();
    const { toggleShowCreateEnvModal } = this.props;
    toggleShowCreateEnvModal(true);
  };

  parseExcelFile = (e) => {
    // console.log("parse excel files", e.target.files);
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        try {
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
          const { addListOfPoints } = this.props;
          addListOfPoints(json);
        } catch (err) {
          toast.error(
            "Fail to upload. Please make sure the file is a spreadsheet",
          );
        }
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  handleStylesWhenSearching = (isSearching, exitSearch) => {
    const { isSearching: currentIsSearching } = this.state;
    if (currentIsSearching !== isSearching) {
      this.setState({ isSearching });
    }
    if (exitSearch) {
      const { handleSearch } = this.props;
      handleSearch();
    }
  };

  handleClickSearchResult = (pin) => {
    const { handleClickSearchResult } = this.props;
    this.setState({ isSearching: false });
    handleClickSearchResult(pin);
  };

  handleClickCreateNewSwab = () => {
    const {
      isSearching, imageSrc, toggleAddingSwab, loading,
    } = this.props;
    if (!imageSrc) {
      toast.error("Must upload map image first");
      return;
    }
    if (!loading && imageSrc === "Not Found") {
      toast.error("Map image must be loaded");
      return;
    }
    if (!isSearching) {
      toggleAddingSwab();
    }
  }

  render() {
    const {
      isSearching,
      exportCOAModal,
      isHovered,
    } = this.state;

    const {
      pinMap,
      quadrantSelected,
      indexOfQuadrantHoverOver,
      selectedLocationID,
      filterSelected,
      isAddingNewSwab,
      searchResultSelected,
      loading,
      displayNoResultFound,
      toggleAddingSwab,
      setSelectedLocationID,
      updatePinInfo,
      handleAddNewSwab,
      handleHoverQuadrant,
      endPinningSwab,
      handleSelectQuadrant,
      handleSelectFilter,
      handleFilterByDate,
      handleSearch,
      setDisplayTooltipLocationID,
      transformWrapperRef,
      duplicateSwab,
      displayFields,
      isPinningNewSwab,
      togglePinningNewSwab,
      isPinningSwab,
      imageSrc,
      searchRef,
      isClickingQuadrant,
      clickQuadrant,
      toggleReportView,
      showReportView,
      index0,
      delimiter,
      linkPatternFields,
      sampleIDFields,
      getCalendarDates,
      forceReportViewRerender,
      envCalendarRef,
    } = this.props;

    const containerStyles = { height: "100%" };
    const panelContainerStyles = { position: "relative" };

    return (
      <>
        {(pinMap.size > 0 // all cases that show EnvSearch (disabled or not)
          || (pinMap.size === 0 && displayNoResultFound)
          || (pinMap.size === 0 && loading)
          ? (
            <div style={containerStyles}>
              <div style={panelContainerStyles}>
                <>
                  {/* {" "}
                  {showCalendar && (
                  <CalendarDropdown
                    getSelectedDates={this.getSelectedDates}
                    getCalendarDates={getCalendarDates}
                    displayDateSelected={this.displayDateSelected}
                    handleSearchDate={handleFilterByDate}
                    clearDate={this.handleClearSearchByDate}
                    onToggleModal={this.handleShowCalendar}
                    saveDateHistory={this.saveDateHistory}
                    handleCloseDateClick={this.handleCloseDateClick}
                  />
                  )} */}
                  <div className={`AnalyticsListView__Search ${loading ? "AnalyticsListView__Search--grayOut" : ""}`}>
                    <EnvSearch
                      filterSelected={filterSelected}
                      handleSelectFilter={handleSelectFilter}
                      handleFilterByDate={handleFilterByDate}
                      getCalendarDates={getCalendarDates}
                      searchResultSelected={searchResultSelected}
                      handleStylesWhenSearching={this.handleStylesWhenSearching}
                      handleSearch={handleSearch}
                      handleClickSearchResult={this.handleClickSearchResult}
                      isAddingNewSwab={isAddingNewSwab}
                      isPinningNewSwab={isPinningNewSwab}
                      isClickingQuadrant={isClickingQuadrant}
                      ref={searchRef}
                      envCalendarRef={envCalendarRef}
                      showReportView={showReportView}
                    />
                  </div>
                </>
                {(loading || isAddingNewSwab || isClickingQuadrant || showReportView) && (<div className="disable-clicking-search" />)}
              </div>
              <div className="environment-analytics-list-view-buttons-and-list">
                {!isHovered
                && (
                <div className="create-and-upload-swab-container">
                  <AnimatePresence>
                    <motion.div
                      initial="initial"
                      animate="initial"
                      exit="hover"
                      variants={{
                        initial: { opacity: 1, scale: 1 },
                        hover: { opacity: 0, scale: 0.95 },
                      }}
                      transition={{ duration: 0.3, ease: "easeOut" }}
                      onMouseEnter={isPinningNewSwab ? null : () => this.setState({ isHovered: true })}
                      className={loading || isSearching || showReportView || isPinningNewSwab ? "newSwabBtn disable" : "newSwabBtn enable"}
                    >
                      <NewSwabIcon className="newSwabBtn__icon" fill={loading || isSearching || showReportView || isPinningNewSwab ? "var(--color-content-disabled)" : "var(--color-primary)"} />
                      <span className="newSwabBtn__label">New Swab</span>
                    </motion.div>
                  </AnimatePresence>

                  {/* <div
                    className={loading || isSearching || showReportView ? "exportCOABtn disable" : "exportCOABtn enable"}
                    onClick={() => this.setState({ exportCOAModal: true })}
                  >
                    <ExportCOA fill={loading || isSearching || showReportView ? "#ccd1d8" : "#26ABE1"} />
                    Export COA
                  </div> */}

                  {(isAddingNewSwab || isClickingQuadrant || showReportView || isPinningNewSwab) && (
                  <div className="create-new-swab-grayed-out" />
                  )}
                </div>
                )}
                {isHovered && (
                <div
                  onMouseLeave={isPinningNewSwab ? null : () => this.setState({ isHovered: false })}
                  className="create-upload-swab-container-maindiv"
                >
                  <div
                    className={loading || isSearching || showReportView || isPinningNewSwab ? "newSwabBtn disable" : "newSwabBtn enable"}
                  >
                    <NewSwabIcon className="newSwabBtn__icon" fill={loading || isSearching || showReportView || isPinningNewSwab ? "var(--color-content-disabled)" : "var(--color-primary)"} />
                    <span className="newSwabBtn__label">New Swab</span>
                  </div>
                  <div className="create-upload-swab-container">
                    <Button
                      className={loading || isSearching || showReportView || isPinningNewSwab ? "createNewSwabBtn disable" : "createNewSwabBtn enable"}
                      onClick={loading || isSearching || showReportView || isPinningNewSwab ? null : this.handleClickCreateNewSwab}
                      type="default"
                      icon={<PlusOutlined className="createNewSwabBtn__icon" />}
                    >
                      Create New Swab
                    </Button>
                    <Button
                      className={loading || isSearching || showReportView || isPinningNewSwab ? "uploadSwabFileBtn disable" : "uploadSwabFileBtn enable"}
                      onClick={showReportView || isPinningNewSwab ? null : this.handleAddFile}
                      type="default"
                      icon={<UploadOutlined className="uploadSwabFileBtn__icon" />}
                    >
                      Upload Swab File
                    </Button>
                  </div>
                </div>
                )}
                <div className="AnalyticsListView__PinListContainer">
                  {!loading && pinMap.size > 0 && (
                  <PinList
                    pinMap={pinMap}
                    imageSrc={imageSrc}
                    loading={loading}
                    quadrantSelected={quadrantSelected}
                    indexOfQuadrantHoverOver={indexOfQuadrantHoverOver}
                    selectedLocationID={selectedLocationID}
                    setSelectedLocationID={setSelectedLocationID}
                    setDisplayTooltipLocationID={setDisplayTooltipLocationID}
                    isAddingNewSwab={isAddingNewSwab}
                    isSearching={isSearching}
                    handleAddNewSwab={handleAddNewSwab}
                    toggleAddingSwab={toggleAddingSwab}
                    duplicateSwab={duplicateSwab}
                    updatePinInfo={updatePinInfo}
                    endPinningSwab={endPinningSwab}
                    handleHoverQuadrant={handleHoverQuadrant}
                    handleSelectQuadrant={handleSelectQuadrant}
                    transformWrapperRef={transformWrapperRef}
                    displayFields={displayFields}
                    index0={index0}
                    delimiter={delimiter}
                    linkPatternFields={linkPatternFields}
                    sampleIDFields={sampleIDFields}
                    isPinningNewSwab={isPinningNewSwab}
                    togglePinningNewSwab={togglePinningNewSwab}
                    isPinningSwab={isPinningSwab}
                    clickQuadrant={clickQuadrant}
                    isClickingQuadrant={isClickingQuadrant}
                    searchResultSelected={searchResultSelected}
                    toggleReportView={toggleReportView}
                    showReportView={showReportView}
                    forceReportViewRerender={forceReportViewRerender}
                  />
                  )}
                  {loading && (
                  <div className="environment-analytics-list-view-content-loader">
                    <ListViewContentLoader amount={10} />
                  </div>
                  )}
                </div>
                {!loading && displayNoResultFound && (
                  <div className="AnalyticsListView__DisplayNoResultFound">
                    <img
                      alt="no result"
                      src={pumpkin}
                      className="AnalyticsListView__NoResultPumpkin"
                    />
                    <div className="AnalyticsListView__NoResultText">
                      No Result Found
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : ( // The case when EnvSearch is not shown (pinmap is empty, loading is false, displayNoResults is false)
            <div className="AnalyticsListView--emptyList">
              <div className="envAnalyticsUploadButton" onClick={this.handleAddFile}>
                <span>
                  Upload Swab Files
                </span>
                <img
                  alt="addFileIcon"
                  src={addFileIcon}
                  className="AnalyticsListView__AddFileIcon"
                />
                <input
                  id="docUploadInput"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  ref={this.docUploadInput}
                  type="file"
                  onChange={this.parseExcelFile}
                    // multiple
                  hidden
                />
              </div>
            </div>
          ))}
        {
            exportCOAModal && <ExportCOAModal handleCloseModal={() => this.setState({ exportCOAModal: false })} />
          }
      </>
    );
  }
}
